import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function ContactLensesService(props) {
  return <EyefinitySectionFields {...props} sectionName="contact_lenses_service" title="Contact Lenses Service" />
}
